import { defineMessages } from 'react-intl';

export default defineMessages({
  PaidSearch: { id: 'app.MediaType.PaidSearch', defaultMessage: 'Paid Search' },
  MobilePaidSearch: { id: 'app.MediaType.MobilePaidSearch', defaultMessage: 'Mobile Paid Search' },
  Native: { id: 'app.MediaType.Native', defaultMessage: 'Native' },
  AudienceAds: { id: 'app.MediaType.AudienceAds', defaultMessage: 'Audience Ads' },
  LinkedInAds: { id: 'app.MediaType.LinkedInAds', defaultMessage: 'LinkedIn Ads' },
});
